import React, { useState, useEffect } from "react";
import axios from "axios";

export const AttendanceToggle = (props) => {
    const [enabled, setEnabled] = useState(!!props?.enabled);

    const url = `/v1/courses/${props?.courseUUID}/students/${props.userUUID}/`;

    const toggleOption = async (enabled) => {
        await axios.patch(url, {
            attended: enabled
        });
        setEnabled(enabled);

        if (typeof props?.onSuccess === "function") {
            props.onSuccess();
        }
    };

    useEffect(() => {
        setEnabled(props?.enabled);
    }, [props?.enabled]);

    return (
        <div>
            <input type="checkbox" name={props?.name} value={enabled} disabled={!!props.isCancelled} checked={enabled} onChange={() => toggleOption(!enabled)} />
        </div>
    );
};
